/*
Copyright 2021 Tamal Anwar Chowdhury

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import React, { Component, useEffect, useState } from 'react'
import { elements } from './data'

function Element(props: any) {
  const [hover, setHover] = useState(false)
  const [element, setElement] = useState(null)

  useEffect(() => {
    let { num }: any = props
    let element = elements[num]
    setElement(element)
  }, [props])

  const openInfo = (event: any) => {
    props.insertElement && props.insertElement(props.num)
  }

  const onMouseEnter = (event: any) => {
    setHover(true)
  }

  const onMouseLeave = (event: any) => {
    setHover(false)
  }

  return (
    <div
      title={element && element.name ? element.name : null}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={openInfo}
      className={`element element-${props?.num} ${element?.category} ${
        hover ? 'active' : ''
      }`}
    >
      <div className="number">{element?.number}</div>
      <div className="symbol">{element?.symbol}</div>
      <div className="element-name">{element?.name}</div>
    </div>
  )
}

export default Element

// export default class Element extends React.Component<any, any> {
//   constructor(props: any) {
//     super(props);

//     this.state = {
//       hover: false,
//     };
//   }

//   render() {
//     let { num }: any = this.props;
//     let element = elements[num];
//     return (
//       <div
//         title={element && element.name ? element.name : null}
//         onMouseEnter={this.onMouseEnter}
//         onMouseLeave={this.onMouseLeave}
//         onClick={this.openInfo}
//         className={`element element-${num} ${element?.category} ${
//           this.state.hover ? "active" : ""
//         }`}
//       >
//         <div className="number">{element?.number}</div>
//         <div className="symbol">{element?.symbol}</div>
//         <div className="element-name">{element?.name}</div>
//       </div>
//     );
//   }
// }
